<template>
    <!-- 新增供应商 -->
    <div class="supplier-wrapper declare-detail">
        <Row type="flex" justify="space-between" align="middle">
            <div class="title-l">
                <router-link to="/index/supplier" class="span-box">
                    <Icon type="ios-arrow-back" />
                    <span>{{$route.query.id ? '编辑供应商' : '新增供应商'}}</span>
                </router-link>
            </div>
        </Row>
        <Form :model="form" :label-width="100" :rules="rules" ref="form">
            <Form-item label="供应商名称" prop="name" class="width-50" v-if="!$route.query.id">
                <Input v-model="form.name" placeholder="请输入供应商名称"></Input>
            </Form-item>
            <Form-item label="供应商名称" v-else>
                <span>{{supplierInfo.supplierName}}</span>
            </Form-item>
            <Form-item label="联系人电话" class="width-50" v-if="!$route.query.id">
                <Input v-model="form.conPhone" placeholder="请输入联系人电话"></Input>
            </Form-item>
            <Form-item label="联系人姓名" class="width-50" v-if="!$route.query.id">
                <Input v-model="form.conName" placeholder="请输入联系人姓名"></Input>
            </Form-item>
            <Form-item label="选择厂"  class="checkbox-block">
                <Checkbox-group v-model="form.depart">
                    <Checkbox
                    v-for="(item, index) in department"
                    :label="item.cliqueNo"
                    :key="index">{{item.cliqueName}}</Checkbox>
                </Checkbox-group>
            </Form-item>
            <Form-item label="物资分类" prop="classify"  class="checkbox-block" v-if="!$route.query.id">
                <Checkbox-group v-model="form.classify">
                    <Checkbox
                    v-for="(item, index) in classifies"
                    :label="item.classifyNo"
                    :key="index">{{item.classifyName}}</Checkbox>
                </Checkbox-group>
            </Form-item>
            <Form-item>
                <Button type="primary" class="btn-140" @click="handleSubmit('form')">提交</Button>
            </Form-item>
        </Form>
    </div>
</template>

<script>
import { adminGetAllClassify, getAllClique, addSupplier, updateSupplier, adminGetSupplierInfo } from '@/graphql/graphql.js';
import Cookies from 'js-cookie';

export default {
    data() {
        return {
            form: {
                name: '',
                conName: '',
                conPhone: '',
                address: '',
                depart: [],
                classify: []
            },
            rules: {
                name: [
                    { required: true, message: '名称不能为空', trigger: 'blur' }
                ],
                classify: [
                    { required: true, type: 'array', min: 1, message: '请选择物资分类', trigger: 'change' }
                ]
            },
            department: [],
            classifies: [],
            supplierInfo: {}
        };
    },
    mounted() {
        this.getProviderAllClique();
        this.getAllClassify();
        if (this.$route.query.id) {
            this.adminGetSupplierInfo();
        }
    },
    methods: {
        getAllClassify() {
            this.$apollo.query({
                query: adminGetAllClassify,
                context: { useApi1: false },
                fetchPolicy: 'network-only'
            }).then(res => {
                const result = res.data.adminGetAllClassify;
                if (result && result.code === 200) {
                    this.classifies = result.data;
                    this.form.classify = [];
                    this.classifies.forEach(item => {
                        this.form.classify.push(item.classifyNo);
                    });
                }
            });
        },
        // 获取所有可进入的组织
        getProviderAllClique() {
            this.$apollo.query({
                query: getAllClique,
                variables: {
                    supplierNo: Cookies.getJSON('supplierNo').toString()
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.getAllClique;
                if (data && data.code === 200) {
                    this.department = data.data;
                }
            });
        },
        adminGetSupplierInfo() {
            this.$apollo.query({
                query: adminGetSupplierInfo,
                context: { useApi1: false },
                variables: {
                    id: Number(this.$route.query.id)
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.adminGetSupplierInfo;
                if (data && data.code === 200) {
                    this.supplierInfo = data.data;
                    this.form.depart = data.data.cliqueNos;
                }
            });
        },
        handleSubmit(name) {
            if (this.$route.query.id) {
                this.$apollo.mutate({
                    mutation: updateSupplier,
                    context: { useApi1: false },
                    variables: {
                        cliqueNos: this.form.depart,
                        supplierNo: this.supplierInfo.supplierNo
                    }
                }).then(res => {
                    const data = res.data.updateSupplier;
                    if (data && data.code === 200) {
                        this.$setNotice('更新成功');
                        setTimeout(() => {
                            this.$router.go(-1);
                        }, 1000);
                    } else {
                        this.$Message.error(data.message);
                    }
                });
            } else {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        const form = this.form;
                        this.$apollo.mutate({
                            mutation: addSupplier,
                            context: { useApi1: false },
                            variables: {
                                supplierInfo: {
                                    supplierName: form.name,
                                    mobile: form.conPhone,
                                    username: form.conName
                                },
                                cliqueNos: form.depart,
                                cliassifys: form.classify
                            }
                        }).then(res => {
                            const data = res.data.addSupplier;
                            if (data && data.code === 200) {
                                this.$setNotice('新增成功');
                                setTimeout(() => {
                                    form.name = '';
                                    form.conPhone = '';
                                    form.conName = '';
                                    form.depart = [];
                                    form.classify = [];
                                    this.classifies.forEach(item => {
                                        form.classify.push(item.classifyNo);
                                    });
                                }, 2000);
                            } else {
                                this.$Message.error(data.message);
                            }
                        });
                    } else {
                        this.$Message.error('请填写相应的信息!');
                    }
                });
            }
        }
    }
};
</script>

<style lang="stylus">
.width-50 {
    width: 50%;
}
.width-80 {
    width: 80%;
}
.btn-140 {
    width: 140px;
    height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/views/supplier/add/index.vue